

// Helper function to format currency (robust to Money objects, strings, nulls)
const formatCurrency = (amount, decimalPlaces = 2) => {
    let n;
    try {
        if (amount == null) {
            n = 0;
        } else if (typeof amount === 'object') {
            // Support djmoney Money object shape or any object with an 'amount' property
            if (Object.prototype.hasOwnProperty.call(amount, 'amount')) {
                n = Number(amount.amount);
            } else {
                // Try to coerce object directly or via valueOf/toString
                const maybeNumber = Number(amount.valueOf ? amount.valueOf() : amount);
                n = Number.isFinite(maybeNumber) ? maybeNumber : Number(String(amount));
            }
        } else {
            n = Number(amount);
        }
    } catch (e) {
        n = 0;
    }
    if (!Number.isFinite(n)) n = 0;

    const roundedAmount = n.toFixed(decimalPlaces);
    return `$${Number(roundedAmount).toLocaleString(undefined, { minimumFractionDigits: decimalPlaces, maximumFractionDigits: decimalPlaces })}`;
};

// Helper function to format interest rates or percents
const formatRate = (amount, decimalPlaces) => {
      const ratePercent = (amount * 100).toFixed(decimalPlaces);
      return `${ratePercent}%`;
    };

// Function to calculate weighted average interest rates for time series
function calculateWeightedAvgInterestRate(outstandingAmounts, currentRates) {
  const sumProduct = outstandingAmounts.reduce((acc, amt, index) => {
    return acc + amt * currentRates[index];
  }, 0);

  const totalOutstanding = outstandingAmounts.reduce((acc, amt) => acc + amt, 0);

  return totalOutstanding ? (sumProduct / totalOutstanding) : 0;
}

// function calculateSeriesWeightedAvg(outstandingSeries, rateSeries) {
//   const result = [];
//   const length = outstandingSeries[0].length; // assuming all arrays have same length
//
//   for (let i = 0; i < length; i++) {
//     // Collect per time point
//     const outstandingAtTime = outstandingSeries.map(arr => arr[i]);
//     const ratesAtTime = rateSeries.map(arr => arr[i]);
//     // Calculate weighted average for this time
//     const weightedAvg = calculateWeightedAvgInterestRate(outstandingAtTime, ratesAtTime);
//     result.push(weightedAvg);
//   }
//   return result; // series of weighted averages
// }


export {formatCurrency, formatRate, calculateWeightedAvgInterestRate};